import React from 'react';
import styled from 'styled-components';

import { PICTURES, AUTO_PICTURES } from 'content';

function Pictures() {
  return (
    <Div>
      <div className="grid">
        {[...AUTO_PICTURES, ...PICTURES].map(pic => (
          <figure key={pic.id} className="tile">
            <img src={pic.src} alt={pic.title} />
            <figcaption>
              <div className="title">{pic.title}</div>
              {pic.description && <div className="desc">{pic.description}</div>}
            </figcaption>
          </figure>
        ))}
      </div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: auto;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);
  padding: 12px;

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
    width: 100%;
    align-content: start;
  }
  .tile {
    margin: 0;
    padding: 8px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 -2px 3px rgba(0, 0, 0, 0.05);
    background: #fff;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
  figcaption {
    margin-top: 6px;
  }
  .title {
    font-weight: 700;
    font-size: 12px;
  }
  .desc {
    font-size: 11px;
    color: #444;
  }
`;

export default Pictures;
